<template>
    <v-row dense :no-gutters="!$vuetify.breakpoint.xsOnly">
        <v-col v-if="!editMode" cols="12" sm="10"
            ><span class="label">{{ contacts.contact_type_name }}</span>
            <span v-if="!editMode" class="gray--text ml-3">{{ contacts.contr_contact_value }}</span>
        </v-col>
        <v-col v-if="editMode" cols="12" class="pl-3 pr-3">
            <v-form ref="contactForm" class="d-flex flex-column">
                <v-select
                    outlined
                    dense
                    :items="CTT"
                    item-text="contact_type_name"
                    item-value="record_id"
                    v-model="contacts.contact_type_rid"
                    :rules="[required]"
                ></v-select>

                <v-text-field outlined dense v-model="contacts.contr_contact_value" :rules="[required]"></v-text-field>
            </v-form>
        </v-col>
        <v-col v-if="isAvailable" :class="{ 'd-flex': true, 'align-center': !editMode, 'align-start justify-center': editMode }" :cols="editMode ? 12 : 2">
            <v-tooltip v-if="!editMode" bottom open-delay="500">
                <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openEdit" v-show="!isNew"> edit </v-icon>
                </template>
                <span>{{ $t('Изменить') }}</span>
            </v-tooltip>
            <div v-else class="mt-1">
                <v-tooltip bottom open-delay="500">
                    <template #activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="update"> mdi-checkbox-marked-circle </v-icon>
                    </template>
                    <span>{{ $t('Сохранить') }}</span>
                </v-tooltip>
                <v-tooltip bottom open-delay="500">
                    <template #activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="ml-1" @click="cancelEdit"> mdi-close-circle </v-icon>
                    </template>
                    <span>{{ $t('Отменить') }}</span>
                </v-tooltip>
                <v-tooltip bottom open-delay="500">
                    <template #activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="ml-1" @click="deleteContact" v-show="!isNew"> mdi-delete-circle </v-icon>
                    </template>
                    <span>{{ $t('Удалить') }}</span>
                </v-tooltip>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import translate from '@/utils/translate.util';
import BinCheckMixin from '@/mixins/BIN_Checker';
import FormValidator from '@/mixins/FormValidator';
export default {
    props: ['contacts', 'isNew'],
    mixins: [BinCheckMixin, FormValidator],
    data: () => ({
        editMode: false,
        isAvailable: true,
        contact: {}
    }),
    methods: {
        async update() {
            if (!this.$refs.contactForm.validate()) return;
            this.editMode = false;
            this.$emit('contactSaved', {
                record_id: this.contacts.record_id,
                contact_type_rid: this.contacts.contact_type_rid,
                to_delete: 0,
                value: this.contacts.contr_contact_value
            });
            if (this.isNew) {
                Object.assign(this.contacts, this.contact);
            }
            //console.log(this.contacts);
        },
        async cancelEdit() {
            this.editMode = false;
            Object.assign(this.contacts, this.contact);
        },
        async openEdit() {
            this.editMode = true;
            Object.assign(this.contact, this.contacts);
        },
        async deleteContact() {
            this.editMode = false;
            this.$emit('contactSaved', {
                record_id: this.contacts.record_id,
                contact_type_rid: this.contacts.contact_type_rid,
                to_delete: 1,
                value: this.contacts.contr_contact_value
            });
        },
        async openNew() {
            this.openEdit();
        }
    },
    watch: {},
    computed: {
        ...mapState('request', ['ContactTypes']),
        CTT() {
            return translate(this.ContactTypes, 'full', this.$i18n.locale);
        }
    }
};
</script>
